import React, { useState, useEffect } from "react";
import styles from "./coocies_consent.module.css";
import { Link } from "react-router-dom";
import { getCookie, setCookie } from "../../utils/cookie";


const CookiesConsent = () => {

  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    setShowConsent(!getCookie("cookieConsent"));
  }, []);

  const hadleConsent = () => {
    setShowConsent(false);
    setCookie("cookieConsent", true, {expires: 31104000, path: '/'});
  }

  if (!showConsent) return null;

  return (
    <div className={styles.container}>
      <p className={styles.text}>
        Мы используем файлы
        &nbsp;<Link to="/cookie" target="_blank" className={styles.link}>
          cookie
        </Link>&nbsp;
        для вашего удобства.
      </p>
      <button
        className='button button__small'
        onClick={hadleConsent}
      >Принять</button>
    </div>
  )
};

export default CookiesConsent;
